import React from 'react';

// Consistent colored XP/progress bar used across gamification views
export const XPBar = ({ pct, color = '#2563EB', height = 'h-2', testId }) => (
  <div
    className={`w-full ${height} rounded-full overflow-hidden`}
    style={{ backgroundColor: `${color}20` }}
    data-testid={testId}
  >
    <div
      className="h-full rounded-full transition-all duration-500"
      style={{ width: `${Math.min(Math.max(pct || 0, 0), 100)}%`, backgroundColor: color }}
    />
  </div>
);
